const languagesByType = (languages, type) => languages.filter((item) => item.record_language_type === type);

const extractLanguageIds = (languages) => languages.map((item) => item.language_id || item.language.id);

// Helper: Get language ID from item
const getLanguageId = (item, allLanguages) => {
  if (typeof item === 'string') {
    // Find the language by name in allLanguages
    const language = allLanguages.find((lang) => lang.name === item);
    return language ? language.id : null;
  }
  return item.id;
};

// Helper: Get language name from item
const getLanguageName = (item) => {
  if (typeof item === 'string') {
    return item;
  }
  return item.name;
};

// Helper: Build languages to add
const buildLanguagesToAdd = (finalSpoken, existingSpoken, finalWritten, existingWritten) => [
  ...finalSpoken
    .filter((id) => !existingSpoken.includes(id))
    .map((id) => ({ language_id: id, record_language_type: 'spoken' })),
  ...finalWritten
    .filter((id) => !existingWritten.includes(id))
    .map((id) => ({ language_id: id, record_language_type: 'written' })),
];

// Helper: Build languages to remove
const buildLanguagesToRemove = (existingSpoken, finalSpokenNames, existingWritten, finalWrittenNames) => [
  ...existingSpoken
    .filter((item) => !finalSpokenNames.includes(item.language_name || item.language.name))
    .map((item) => ({ id: item.id })),
  ...existingWritten
    .filter((item) => !finalWrittenNames.includes(item.language_name || item.language.name))
    .map((item) => ({ id: item.id })),
];

const determineLanguageDifferences = (preferredLanguages, formValues, allLanguages = []) => {
  const existingSpokenLanguages = languagesByType(preferredLanguages, 'spoken');
  const existingWrittenLanguages = languagesByType(preferredLanguages, 'written');
  const existingSpokenLanguageIds = extractLanguageIds(existingSpokenLanguages);
  const existingWrittenLanguageIds = extractLanguageIds(existingWrittenLanguages);

  const finalSpokenLanguages = (formValues.preferred_spoken_languages || [])
    .map((item) => getLanguageId(item, allLanguages))
    .filter(Boolean);
  const finalWrittenLanguages = (formValues.preferred_written_languages || [])
    .map((item) => getLanguageId(item, allLanguages))
    .filter(Boolean);

  const finalSpokenLanguageNames = (formValues.preferred_spoken_languages || []).map(getLanguageName);
  const finalWrittenLanguageNames = (formValues.preferred_written_languages || []).map(getLanguageName);

  const languagesToAdd = buildLanguagesToAdd(
    finalSpokenLanguages,
    existingSpokenLanguageIds,
    finalWrittenLanguages,
    existingWrittenLanguageIds,
  );

  const languagesToRemove = buildLanguagesToRemove(
    existingSpokenLanguages,
    finalSpokenLanguageNames,
    existingWrittenLanguages,
    finalWrittenLanguageNames,
  );

  return { languagesToAdd, languagesToRemove };
};

export default determineLanguageDifferences;
